import React from "react";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

/**
 * Card with the button to self-close (not persisted for now)
 * Must pass:
 *  - title={"title of the card"}
 *  - className={classes.someClassName}
 *  - children: what's enclosed between the open and close tag becomes the body of the card
 */
export function InfoCard(props) {
  const {title, subTitle, className, actions, onClose, children} = props;
  return <Card className={className}>
    <CardContent>
      <Typography variant="h5" component="h2">{title}</Typography>
      {subTitle && <Typography color="textSecondary">{subTitle}</Typography>}
      {children}
    </CardContent>
    {(actions || onClose) && <CardActions>
      {actions}
      {onClose && <Button size="small" style={{marginLeft: 'auto'}} onClick={() => onClose()}>Close</Button>}
    </CardActions>}
  </Card>;
}

/**
 * InfoCard which can persist the closed state; needs an extra localstorage persistence 'key'
 */
// export function CloseableInfoCard({closePersistedKey, children, ...others}) {
//   const [closed, setClosed] = usePersistedState(closePersistedKey, false);
//   if (closed) return null;
//   return <InfoCard {...others} onClose={() => setClosed(true)}>{children}</InfoCard>;
// }
